import { render } from "./ShirtCart.vue?vue&type=template&id=364ddf0c"
import script from "./ShirtCart.vue?vue&type=script&lang=js"
export * from "./ShirtCart.vue?vue&type=script&lang=js"
script.render = render

export default script